import util from '../util'

let controller = 'ContaCartaoHistorico'

export default Object.assign({}, util.GetCrud(controller, ['post', 'put', 'getall', 'delete']),{
    GetHistorico: function (dto, options) {
        if (options && options.data) dto.data = options.data
        return util.Axios.GetAll(controller, dto)
      },
})